import type { JobResponse } from "@/lib/api/model/jobResponse";
import type { StageResponse } from "@/lib/api/model/stageResponse";
import type { WizardStageItem } from "./job-store";

/** Sort backend stages by position and normalize into wizard stage items. */
export function mapApiStages(stages: StageResponse[]): WizardStageItem[] {
  return [...stages]
    .sort((a, b) => a.position - b.position)
    .map((s) => ({
      id: s.id,
      name: s.name,
      color: s.color,
      description: s.description ?? "",
      is_system: s.is_system,
      ...(s.origin_ats_name ? { ats_name: s.origin_ats_name } : {}),
    }));
}

/** Load a created/fetched job into the shape the create-job wizard form uses. */
export function mapJobToWizardForm(
  job: JobResponse,
): { title: string; description: string; stages: WizardStageItem[] } {
  return {
    title: job.title,
    description: job.description ?? "",
    stages: mapApiStages(job.stages ?? []),
  };
}
